module.exports = __webpack_public_path__ + "img/grey_charcoal.78b9aaff.jpg";